import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { authRequest } from "../utils/auth";
import "../css/BoardForm.css";

const BoardForm = ({ setPosts }) => {
  const navigate = useNavigate();
  const [title, setTitle] = useState("");
  const [content, setContent] = useState("");
  const [error, setError] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await authRequest("http://35.192.131.111/board/", {
        method: "POST",
        data: { title, content },
      });
      if (response.data.result) {
        const newPost = {
          id: response.data.data.board_id,
          title,
          content,
        };
        if (setPosts) setPosts((prevPosts) => [...prevPosts, newPost]);
        navigate("/board");
      } else {
        setError("게시글 작성 실패: " + response.data.message);
      }
    } catch (error) {
      setError("게시글 작성 중 오류가 발생했습니다.");
      console.error("Error:", error);
    }
  };

  return (
    <div className="board-form-container">
      <form onSubmit={handleSubmit} className="board-form">
        <h2>새 게시글 작성</h2>
        {error && <p className="error">{error}</p>}
        <div>
          <label htmlFor="title">제목</label>
          <input
            type="text"
            id="title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>
        <div>
          <label htmlFor="content">내용</label>
          <textarea
            id="content"
            value={content}
            onChange={(e) => setContent(e.target.value)}
            required
          ></textarea>
        </div>
        <div className="button-group">
          <button type="submit">작성하기</button>
          <button
            type="button"
            onClick={() => navigate("/board")}
            style={{ backgroundColor: "#777" }}
          >
            취소
          </button>
        </div>
      </form>
    </div>
  );
};

export default BoardForm;
